function init(): void {
  /**
   * Prevent errors from calls to console.* from browsers that don't support it.
   */
  // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
  if (!Object.prototype.hasOwnProperty.call(window, 'console')) {
    // @ts-expect-error
    // eslint-disable-next-line rover/no-platform-specific-globals-or-imports
    window.console = {
      assert() {},
      clear() {},
      count() {},
      debug() {},
      dir() {},
      dirxml() {},
      error() {},
      group() {},
      groupCollapsed() {},
      groupEnd() {},
      info() {},
      log() {},
      profile() {},
      profileEnd() {},
      table() {},
      time() {},
      timeEnd() {},
      timeStamp() {},
      trace() {},
      warn() {},
    };
  }
}

const exportedInit = { init };

export default exportedInit;
